import type { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { SkipLink } from './SkipLink';
import type { AppMode } from '@bmkg/core';

interface AppShellProps {
  mode: AppMode;
  children: ReactNode;
}

export function AppShell({ mode, children }: AppShellProps) {
  return (
    <>
      <SkipLink />
      <Header mode={mode} />
      <main id="main" className="main" tabIndex={-1}>
        <div className="main__inner">{children}</div>
      </main>
      <Footer />
    </>
  );
}
